export default {

	selectors: {
		link: 'a, button',
		gallery: '.splide',
		cursor: '.cursor',
		cursorDot: '.cursor--dot',
		cursorGallery: '.cursor--gallery',
		whiteCursor: '.cursor-white',
		hideCursor: '.hide-cursor',
	},

	classes: {
		active: 'active',
		hide: 'hide',
		hidden: 'cursor--hidden',
		white: 'cursor--white',
	},

	init() {
		const links = Array.from(document.querySelectorAll(this.selectors.link));
		const galleries = Array.from(document.querySelectorAll(this.selectors.gallery));
		const cursorWhite = Array.from(document.querySelectorAll(this.selectors.whiteCursor));
		const hide = Array.from(document.querySelectorAll(this.selectors.hideCursor));
		this.cursors = Array.from(document.querySelectorAll(this.selectors.cursor));
		this.cursorDot = document.querySelector(this.selectors.cursorDot);
		this.cursorGallery = document.querySelector(this.selectors.cursorGallery);
		document.addEventListener('mousemove', this.move.bind(this));
		links.forEach((link) => {
			link.addEventListener('mouseenter', this.mouseenter.bind(this));
			link.addEventListener('mouseleave', this.mouseleave.bind(this));
		});
		galleries.forEach((gallery) => {
			gallery.addEventListener('mouseenter', this.galleryEnter.bind(this));
			gallery.addEventListener('mouseleave', this.galleryLeave.bind(this));
		});
		hide.forEach((elm) => {
			elm.addEventListener('mouseenter', this.hideCursorEnter.bind(this));
			elm.addEventListener('mouseleave', this.hideCursorLeave.bind(this));
		});
		cursorWhite.forEach((elm) => {
			elm.addEventListener('mouseenter', this.whiteCursorEnter.bind(this));
			elm.addEventListener('mouseleave', this.whiteCursorLeave.bind(this));
		});
	},

	move(e) {
		this.cursors.forEach((el) => {
			el.style.left = `${e.clientX}px`;
			el.style.top = `${e.clientY}px`;
		});
	},

	mouseenter() {
		if (this.galleryActice) {
			this.cursorGallery.classList.add(this.classes.hide);
			this.cursorDot.classList.remove(this.classes.hide);
		}
		this.cursorDot.classList.add(this.classes.active);
	},

	mouseleave() {
		if (this.galleryActice) {
			this.cursorGallery.classList.remove(this.classes.hide);
			this.cursorDot.classList.add(this.classes.hide);
		}
		this.cursorDot.classList.remove(this.classes.active);
	},

	galleryEnter() {
		this.galleryActice = true;
		this.cursorDot.classList.add(this.classes.hide);
		this.cursorGallery.classList.add(this.classes.active);
	},

	galleryLeave() {
		this.galleryActice = false;
		this.cursorDot.classList.remove(this.classes.hide);
		this.cursorGallery.classList.remove(this.classes.active);
	},

	hideCursorEnter() {
		document.querySelector('body').classList.add(this.classes.hidden);
	},

	hideCursorLeave() {
		document.querySelector('body').classList.remove(this.classes.hidden);
	},

	whiteCursorEnter() {
		this.cursors.forEach((el) => {
			el.classList.add(this.classes.white);
		});
	},

	whiteCursorLeave() {
		this.cursors.forEach((el) => {
			el.classList.remove(this.classes.white);
		});
	},

};
